import { RentReceiptHouse } from "../../../../icons/rent-receipt-icons";

export const Receipt = ({
  content,
  ownerName,
  ownerPan,
}: {
  content: string;
  ownerName: string;
  ownerPan: string;
}) => {
  return (
    <div className="flex justify-between items-center w-full">
      <div className="flex flex-col items-center justify-center w-1/2">
        <div className="shadow-lg flex flex-col items-center justify-center p-8">
          <span className="w-full text-center text-lg font-semibold mb-3">
            Rent Receipt
          </span>
          <div className="text-justify border border-dashed border-primary-500 p-3 text-md ">
            {content}
          </div>
          <div className="flex justify-between w-full mt-4">
            <div className="flex flex-col">
              <p className="text-primary-900 font-semibold text-sm">
                Signature
              </p>
              <p className="pb-1 text-sm border-b border-black">{ownerName}</p>
              {ownerPan && <p className="text-xs">PAN: {ownerPan}</p>}
            </div>
            <div className="w-20 h-20 border text-wrap text-center text-sm border-dashed p-3">
              Revenue Stamp
            </div>
          </div>
        </div>
        <div className="text-base text-center w-2/3 mt-5 font-semibold text-primary-700">
          A copy of this document will also be shared to the email you provided
        </div>
      </div>
      <RentReceiptHouse />
    </div>
  );
};
